export const DEPARTAMENTO_OPERACAO = "OPERAÇÃO";

export const DEPARTAMENTOS_GESTAO_ORCAMENTARIA = [
  "CONSELHO",
  "DIRETORIA EXECUTIVA",
  "DIRETORIA DE DESENVOLVIMENTO DE NEGÓCIOS",
  "DIRETORIA ADMINISTRATIVO FINANCEIRO",
  "DIRETORIA JURÍDICA",
  "DIRETORIA DE PROCESSOS E QUALIDADE",
  "DIRETORIA DE PESSOAS E CULTURA",
  "DIRETORIA MARKETING",
  "DIRETORIA COMERCIAL",
  DEPARTAMENTO_OPERACAO,
  "DESENVOLVIMENTO TECNOLÓGICO",
  "PROJETO IA NATIVE YOUX",
  "DIRETORIA CUSTOMER SUCCESS",
];

// "Custos Gerais" é a visão exclusiva do departamento Operação;
// "Despesas Gerais" cobre todos os demais departamentos.
export const DEPARTAMENTOS_DESPESAS_GERAIS = DEPARTAMENTOS_GESTAO_ORCAMENTARIA.filter(
  (d) => d !== DEPARTAMENTO_OPERACAO
);
export const DEPARTAMENTOS_CUSTOS_GERAIS = [DEPARTAMENTO_OPERACAO];

// "Custo Mão de Obra" é a visão exclusiva do departamento Operação;
// "Despesas Mão de Obra" cobre todos os demais departamentos (mesma lógica acima).
export const DEPARTAMENTOS_DESPESAS_MAO_DE_OBRA = DEPARTAMENTOS_GESTAO_ORCAMENTARIA.filter(
  (d) => d !== DEPARTAMENTO_OPERACAO
);
export const DEPARTAMENTOS_CUSTO_MAO_DE_OBRA = [DEPARTAMENTO_OPERACAO];

// Mapeamento role → departamento(s) que ela pode ver/editar em Gestão Orçamentária.
// "admin" não aparece aqui — ele sempre enxerga todos os departamentos.
// Espelha backend/config.py DEPARTAMENTO_POR_ROLE — mantenha os dois em sincronia.
export const DEPARTAMENTO_POR_ROLE = {
  CONSELHO: ["CONSELHO"],
  MARKETING: ["DIRETORIA MARKETING"],
  TI: ["DESENVOLVIMENTO TECNOLÓGICO"],
  ADMFIN: ["DIRETORIA ADMINISTRATIVO FINANCEIRO"],
  NEGOCIOS: ["DIRETORIA DE DESENVOLVIMENTO DE NEGÓCIOS"],
  EXECUTIVA: ["DIRETORIA EXECUTIVA"],
  QUALIDADE: ["DIRETORIA DE PROCESSOS E QUALIDADE"],
  RH: ["DIRETORIA DE PESSOAS E CULTURA"],
  JURIDICO: ["DIRETORIA JURÍDICA"],
  OPERACAO: [DEPARTAMENTO_OPERACAO],
  ASSISTENTEOPERACAO: [DEPARTAMENTO_OPERACAO],
  COMERCIAL: ["DIRETORIA COMERCIAL"],
  VIAGEMCOMERCIAL: ["DIRETORIA COMERCIAL"],
  FACILITIES: ["DIRETORIA ADMINISTRATIVO FINANCEIRO"],
  "PESSOA&CULTURA": ["DIRETORIA DE PESSOAS E CULTURA"],
  GESTOR_ESTRATEGICO: [
    "DIRETORIA JURÍDICA",
    "DIRETORIA DE PROCESSOS E QUALIDADE",
    "DIRETORIA EXECUTIVA",
  ],
};

// Departamentos que a role enxerga: admin vê todos, as demais seguem DEPARTAMENTO_POR_ROLE
// (role sem mapeamento não vê nenhum).
export function departamentosVisiveis(role) {
  if (role === "admin") return DEPARTAMENTOS_GESTAO_ORCAMENTARIA;
  return DEPARTAMENTO_POR_ROLE[role] || [];
}

function rolesComAcesso(departamentosAlvo) {
  const roles = Object.keys(DEPARTAMENTO_POR_ROLE).filter((role) =>
    DEPARTAMENTO_POR_ROLE[role].some((d) => departamentosAlvo.includes(d))
  );
  return ["admin", ...roles];
}

// Roles com pelo menos 1 departamento em cada submódulo — usados em allowedRoles das rotas/menus.
export const ROLES_DESPESAS_GERAIS = rolesComAcesso(DEPARTAMENTOS_DESPESAS_GERAIS);
export const ROLES_CUSTOS_GERAIS = rolesComAcesso(DEPARTAMENTOS_CUSTOS_GERAIS);
export const ROLES_GESTAO_ORCAMENTARIA = ["admin", ...Object.keys(DEPARTAMENTO_POR_ROLE)];
